import Auth from 'j-toker';
import { browserHistory } from 'react-router';
import store from 'store';
import * as authentication from 'actions/authenticationActions';
import { isAuthenticating } from 'helpers/Authentication/index';
import logoutUser from './logoutUser';

export default function authenticateMaintenance(nextState, replace, callback) {
  if (isAuthenticating()) {
    return;
  }

  if (!Auth.user || !Auth.user.first_name || !Auth.user.type) {
    return;
  }

  if (Auth.user.type !== 'maintenance') {
    logoutUser();
    callback();
    return;
  }

  const currentLocation = browserHistory.getCurrentLocation();

  // eslint-disable-next-line
  localStorage.setItem('currentConfigName', '"maintenance"');
  store.dispatch(authentication.logUserIn());

  window.gtag('config', 'GA_MEASUREMENT_ID', {
    page_path: currentLocation.pathname,
  });

  callback();
  return;
}
